import _filter from 'lodash/filter';
import _each from 'lodash/each';
import _sortBy from 'lodash/sortBy';
import _find from 'lodash/find';

function Ctrl($rootScope, $scope, $q, bookingHelpers, loggerService, modalService, metaTagService, membershipService,
  jsSdkCuratedListFollow, jsSdkBooking, jsSdkUser, jsSdkReview) {
  metaTagService.set({
    title: 'Dashboard | Tablelist',
    description: 'Manage your VIP table bookings, make changes to your account and more.'
  });

  $scope.loading = true;
  $scope.bookings = [];
  $scope.reviews = [];
  $scope.pendingReviews = [];
  $scope.finishedReviews = [];

  $scope.isSubscribed = function() {
    return membershipService.isUserSubscribed();
  };

  $scope.bookingsPromise = jsSdkBooking.listByUserId($rootScope.currentUser.id, {
    fields: 'event(), venue()'
  });

  $scope.bookingsPromise
    .then(function success(response) {
      $scope.bookings = _sortBy(response, function(booking) {
        return booking.date;
      });

      $scope.tableCount = _filter(response, function(booking) {
        return bookingHelpers.isTable(booking) && bookingHelpers.isUpcomingBooking(booking);
      }).length;

      $scope.ticketCount = _filter(response, function(booking) {
        return bookingHelpers.isTicket(booking) && bookingHelpers.isUpcomingBooking(booking);
      }).length;
    })
    .catch(response => {
      loggerService.error(response);
    });

  $scope.reviewsPromise = jsSdkReview.listByUserId(jsSdkUser.getCurrentUser().id);

  $scope.reviewsPromise
    .then(function success(response) {
      $scope.reviews = response;

      $scope.pendingReviewCount = _filter(response, function(review) {
        return review.pending === true;
      }).length;
    })
    .catch(response => {
      loggerService.error(response);
    });

  $scope.bookingReviewPromise = $q.all([
      $scope.bookingsPromise,
      $scope.reviewsPromise
    ])
    .then(values => {
      $scope.loading = false;

      const bookings = values[0];
      const reviews = ($scope.reviews.length > 0) ? $scope.reviews : values[1];

      return $q(function(resolve) {
        _each(reviews, function(review) {
          const booking = _find(bookings, {
            id: review.booking
          });

          if (!booking) return;

          if (review.pending) {
            $scope.pendingReviews.push({
              review: review,
              booking: booking
            });
          } else {
            $scope.finishedReviews.push({
              review: review,
              booking: booking
            });
          }
        });

        return resolve();
      });
    });

  $scope.followedLists = [];

  _loadFollowedCuratedLists();

  function _loadFollowedCuratedLists() {
    const user = jsSdkUser.getCurrentUser();

    if (!user) return;

    const options = {
      fields: 'curatedList()'
    };

    jsSdkCuratedListFollow.listByUserId(user.id, options)
      .then(function(resp) {
        $scope.followedLists = resp;
      }, function() {});
  }

  $scope.contactSupport = function(msg) {
    modalService.contactSupport({
      message: msg
    });
  };
}

Ctrl.$inject = [
  '$rootScope',
  '$scope',
  '$q',
  'bookingHelpersService',
  'loggerService',
  'modalService',
  'metaTagService',
  'membershipService',
  'jsSdk.curatedListFollow',
  'jsSdk.booking',
  'jsSdk.user',
  'jsSdk.review'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/components/account/accountCtrl.js